import { useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import s from './AudienceCard.module.scss'

import { GETAudience } from 'types/audience'

import { useModal } from 'hooks/useModal'
import { useShowDropdown } from 'hooks/useShowDropdown'

import { DeleteIcon } from 'assets/icons/DeleteIcon'
import { EditIcon } from 'assets/icons/EditIcon'
import { ExclamationIcon } from 'assets/icons/ExclamationIcon'
import { ImageIcon } from 'assets/icons/ImageIcon'
import { InfoIcon } from 'assets/icons/InfoIcon'

import { Card } from 'components/UI/Card/Card'
import ConfirmMessage from 'components/UI/ConfirmMessage'
import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { Dropmenu } from 'components/UI/Dropmenu/Dropmenu'

interface AudienceCardProps {
  item: GETAudience
  deleteItem: (id: number) => void
}

const AudienceCard = ({ item, deleteItem }: AudienceCardProps) => {
  const { show, handleClose, handleOpen } = useModal()
  const { ref, showDropdown } = useShowDropdown()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const creativesCount = useMemo(
    () => item.seg_rules.map((i) => i.seg_rule_creatives.length).reduce((acc, num) => acc + num, 0),
    []
  )

  const openCampaignInfoModal = () => {
    navigate(`${item.id}?${searchParams}`)
  }

  const editHandler = () => {
    navigate(`edit/${item.id}?${searchParams}`)
  }

  return (
    <>
      <Card onClick={openCampaignInfoModal} variant="secondary" className={s.wrapper}>
        <Card.Info className={s.cardInfo}>
          <div className={s.info}>
            <Card.CroppedText>{item.name}</Card.CroppedText>
            <div className={s.infoDescription}>
              <span className={s.infoRules}>
                <ExclamationIcon className={s.descriptionIcon} />
                {item.seg_rules?.length} Rules applied
              </span>
              <span className={s.infoCreatives}>
                <ImageIcon className={s.descriptionIcon} />
                {creativesCount} Creatives selected
              </span>
            </div>
          </div>
          <div className={s.buttonsWrapper} onClick={(e) => e.stopPropagation()}>
            <CustomButton variant="secondary" onClick={openCampaignInfoModal} small>
              <InfoIcon className={s.infoIcon} />
            </CustomButton>
            <Dropmenu
              show={showDropdown}
              cref={ref}
              variant="secondary"
              small
              items={[
                { icon: <EditIcon />, title: 'Edit', onClick: editHandler, hide: item.in_use },
                { icon: <DeleteIcon />, title: 'Delete', onClick: handleOpen },
              ]}
            />
          </div>
        </Card.Info>
      </Card>
      <>
        <ConfirmMessage
          isOpen={show}
          handleClose={handleClose}
          message={`Are you sure you want to delete the "${item.name}" template?`}
          deleteItem={() => deleteItem(item.id)}
          id={item.advert_id}
        />
      </>
    </>
  )
}

export default AudienceCard
